(function(){
/* Lichte review-killer — CSS doet 99%; JS alleen DOM-removal van dynamische injecties */
var SELS=['#noReviewsWidgetText','#starGroupContainer','#writeGroupButton','#writeReviewButton','[id^="aftership-reviews"]','[id^="aftership-review"]','[class*="aftership-reviews-widget"]','[class*="aftership-review"]'];
var MARKER=SELS.join(',');
function nuke(el){
  var node=el, parent=node.parentElement;
  while(parent && parent!==document.body && parent.children.length===1){ node=parent; parent=node.parentElement; }
  try{ node.remove(); }catch(e){}
}
function killAll(){
  document.querySelectorAll(MARKER).forEach(nuke);
}
/* Eén keer bij DOM-ready */
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', killAll);
else killAll();
/* Eén keer bij window load */
window.addEventListener('load', killAll);
/* MutationObserver alleen op body, alleen op nieuwe nodes (geen subtree scan) */
if('MutationObserver' in window){
  var pending=false;
  var mo=new MutationObserver(function(muts){
    for(var i=0;i<muts.length;i++){
      var added=muts[i].addedNodes;
      for(var j=0;j<added.length;j++){
        var n=added[j];
        if(n.nodeType===1 && (n.matches && n.matches(MARKER) || n.querySelector && n.querySelector(MARKER))){
          if(!pending){
            pending=true;
            requestAnimationFrame(function(){ killAll(); pending=false; });
          }
          break;
        }
      }
    }
  });
  /* Wacht tot body bestaat */
  function startObs(){ if(document.body) mo.observe(document.body,{childList:true,subtree:true}); }
  if(document.body) startObs(); else document.addEventListener('DOMContentLoaded', startObs);
  /* Stop observer na 30 seconden — daarna komt geen widget meer */
  setTimeout(function(){ try{ mo.disconnect(); }catch(e){} }, 30000);
}
})();
